$(function(){
   var swiperMobileMenu = new Swiper("#mobileonlymenu", {
          direction: 'horizontal',
          slidesPerView:"auto",
          spaceBetween: 10,
          grabCursor:true,
          loop:false,
          preventClicks :true,
          a11y: false,
          speed: 400,
          cssWidthAndHeight: true,
          visibilityFullFit: true,
          autoResize: false,
          slideToClickedSlide: true,
          freeMode: true,
          resistanceRatio: 0,
          shortSwipes: true,
          longSwipes:false,
          slidesPerGroup:1,
          loop:false, 
          mousewheel: {
          forceToAxis: true
          },
           slideToClickedSlide: false,
          watchSlidesVisibility: true,
          watchSlidesProgress: false,
          navigation: {
            nextEl: ".pull-right1",
            prevEl: ".pull-left1",
          },
      touchAngle:180
        });
  
   var swiperMainCollectio = new Swiper(".sliderMaincollection", {
          direction: 'horizontal',
           slidesPerView:"auto",
          spaceBetween: 14,
          grabCursor:true,
          loop:false,
          speed: 400,
          cssWidthAndHeight: true,
          visibilityFullFit: true,
          autoResize: false,
          slideToClickedSlide: false,
          freeMode: true,
          resistanceRatio: 0,
          shortSwipes: true,
          longSwipes:false,
          slidesPerGroup:1,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          pagination: {
            el: '.swiper-pagination1',
            type: 'progressbar'
          },
          loop:false, 
          mousewheel: {
          forceToAxis: true
          },
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: ".pull-right",
            prevEl: ".pull-left",
          },
      touchAngle:180
        });
   
});
$(function(){
  var mobile_width = $(window).width(); 
  if ((mobile_width <= 767)){
    var swipeLogoList = new Swiper(".logoListGrid", {
          direction: 'horizontal',
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 2,
          },
          autoHeight: true,
          slidesPerView:"auto",
          spaceBetween: 10,
          grabCursor:true,
          loop:false,
          speed: 400,
          cssWidthAndHeight: true,
          visibilityFullFit: true,
          autoResize: false,
          slideToClickedSlide: false,
          freeMode: true,
          resistanceRatio: 0,
          shortSwipes: true,
          longSwipes:false,
          slidesPerGroup:1,
          loop:false, 
          mousewheel: {
          forceToAxis: true
          },
          watchSlidesVisibility: true,
          watchSlidesProgress: false,
          navigation: {
            nextEl: ".nextBtn1",
            prevEl: ".prevBtn1",
          },
      touchAngle:180
        });
  }
  var swiperTestimonial = new Swiper(".hometestimonialsdslider", {
      direction: 'horizontal',
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
      },
      autoHeight: true,
      slidesPerView:"auto",
      spaceBetween: 10,
      grabCursor:true,
      loop:true,
      speed: 400,
      cssWidthAndHeight: true,
      visibilityFullFit: true,
      autoResize: false,
      slideToClickedSlide: false,
      freeMode: true,
      resistanceRatio: 0,
      shortSwipes: true,
      longSwipes:false,
      slidesPerGroup:1,
      mousewheel: {
        forceToAxis: true
      },
      watchSlidesVisibility: true,
      watchSlidesProgress: false,
      navigation: {
        nextEl: ".nextBtnTestimonials",
        prevEl: ".prevBtnTestimonials",
      },
      touchAngle:180
    });
});

window.onresize = function() {
    if (window.innerWidth <= 767) {
      var mobile_width = $(window).width(); 

    var swipeLogoList = new Swiper(".logoListGrid", {
          direction: 'horizontal',
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 2,
          },
          watchOverflow:true,
          autoHeight: true,
          slidesPerView:"auto",
          spaceBetween: 10,
          grabCursor:true,
          loop:false,
          speed: 400,
          cssWidthAndHeight: true,
          visibilityFullFit: true,
          autoResize: false,
          slideToClickedSlide: true,
          freeMode: true,
          resistanceRatio: 0,
          shortSwipes: true,
          longSwipes:false,
          slidesPerGroup:1,
          loop:false, 
          mousewheel: {
          forceToAxis: true
          },
          watchSlidesVisibility: true,
          watchSlidesProgress: false,
          navigation: {
            nextEl: ".nextBtn1",
            prevEl: ".prevBtn1",
          },
      touchAngle:180
        });
    }
}


